import { FetchPolicy } from '@bingads-webui-react/overreact';
import { getDefaultHeaderObj } from '@bingads-webui/overreact-bingads';

export const networkPolicy = FetchPolicy.NetworkOnly;

export function urlDecorator(fn) {
  function decorator(params, originValue) {
    // TODO: Add decoration
    return originValue;
  }

  return params => decorator(params, fn(params));
}

export function headerDecorator(fn) {
  function decorator() {
    return getDefaultHeaderObj();
  }

  return params => decorator(params, fn(params));
}

export function payloadDecorator(fn) {
  function decorator(params, originValue) {
    // TODO: Add decoration
    return originValue;
  }

  return params => decorator(params, fn(params));
}

export function keySelectorDecorator(fn) {
  function decorator(obj, originValue) {
    // TODO: Add decoration
    return originValue;
  }

  return obj => decorator(obj, fn(obj));
}

export function processorDecorator(fn) {
  function decorator(response, request, originValue) {
    // TODO: Add decoration
    return originValue;
  }

  return (response, request) => decorator(response, request, fn(response, request));
}

export const sideEffects = {
  fetch: null,
  refetch: null,
  mutation: null,
  pagination: null,
  add: null,
  destroy: null,
};
